import { usePutMutation } from "@/api/swr/useMutation";
import { companyUserEditSchema } from "@/schema/app/profile/CompanyUser";
import { z } from "zod";

type Config = Parameters<typeof usePutMutation<typeof companyUserEditSchema, z.ZodUndefined>>[3];

export const useEditCompanyMemberProfile = (
  id: number,
  config?: Config
) => {
  return usePutMutation(
    companyUserEditSchema,
    z.undefined(),
    `/app/company_users/${id}`,
    config,
  );
};
